import styled from 'styled-components'
import { fontWeights, colors } from '@/styles'
import StatusBadge from '@/components/status-badge'
import Skeleton from '@/components/skeleton'

type StatusBadgeType =
  | 'error'
  | 'success'
  | 'default'
  | 'warning'
  | 'info'
  | 'blue'
  | 'pending'
  | 'link'
  | 'poor'
  | 'average'
  | 'very_good'
  | 'excellent'
  | 'analyzing'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  padding: 12px;
  background: ${colors.grey96};
  border-bottom: 2px solid ${colors.grey80};
`

const HeaderText = styled.p`
  font-weight: ${fontWeights.mediumBold};
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`
type Color = 'primary' | 'secondary'

type CollapsibleContainerProps = {
  children?: React.ReactNode
  title?: string
  defaultOpen: boolean
  statusType?: StatusBadgeType
  statusSize?: 'small' | 'medium'
  statusTitle?: string
  statusTooltip?: React.ReactNode
  statusTooltipIcon?: boolean
  statusTooltipTheme?: Color
  statusToolTipIcon?: boolean
  isLocked?: boolean
  isLoading?: boolean
}

const CollapsibleContainer: React.FC<CollapsibleContainerProps> = ({
  title = '',
  defaultOpen,
  statusType = 'default',
  statusSize = 'small',
  statusTitle = '',
  statusTooltipIcon,
  statusTooltip,
  statusTooltipTheme,
  isLocked = false,
  isLoading = false,
  children
}) => {
  return (
    <Wrapper>
      <Header>
        <HeaderText>{title}</HeaderText>
        {isLoading ? (
          <Skeleton width={75} height={25} />
        ) : (
          <StatusBadge
            type={statusType}
            size={statusSize}
            title={statusTitle}
            toolTipIcon={statusTooltipIcon}
            tooltip={statusTooltip}
            tooltipTheme={statusTooltipTheme}
            isLocked={isLocked}
          />
        )}
      </Header>
      {children}
    </Wrapper>
  )
}

export default CollapsibleContainer
